import React, { useRef, useEffect, useState } from "react";
import DOMPurify from "dompurify";
/** Only saved semantic formatting is displayed. Remote resources and executable markup are excluded. */
export default function SubmittedDocument({
  html,
  text,
}: {
  html?: string;
  text?: string;
}) {
  const root = useRef<HTMLDivElement>(null),
    [outline, setOutline] = useState<string[]>([]);
  useEffect(() => {
    setOutline(
      Array.from(root.current?.querySelectorAll("h1,h2,h3,h4") || []).map(
        el => el.textContent || ""
      )
    );
  }, [html]);
  if (!html)
    return (
      <div className="review-prose">
        {text || "This document is available in the submitted files below."}
      </div>
    );
  const clean = DOMPurify.sanitize(html, {
    ALLOWED_TAGS: [
      "p",
      "br",
      "h1",
      "h2",
      "h3",
      "h4",
      "h5",
      "h6",
      "strong",
      "b",
      "em",
      "i",
      "u",
      "s",
      "del",
      "ins",
      "sub",
      "sup",
      "blockquote",
      "pre",
      "code",
      "ul",
      "ol",
      "li",
      "table",
      "thead",
      "tbody",
      "tfoot",
      "tr",
      "th",
      "td",
      "hr",
      "span",
    ],
    ALLOWED_ATTR: ["colspan", "rowspan", "start"],
    ALLOW_DATA_ATTR: false,
    ALLOW_ARIA_ATTR: false,
  });
  return (
    <>
      {!!outline.length && (
        <details className="submitted-outline">
          <summary>Document outline</summary>
          <ol>
            {outline.map((title, i) => (
              <li key={i}>
                <button
                  type="button"
                  onClick={() =>
                    root.current
                      ?.querySelectorAll("h1,h2,h3,h4")
                      [i]?.scrollIntoView({ block: "start" })
                  }
                >
                  {title}
                </button>
              </li>
            ))}
          </ol>
        </details>
      )}
      <div
        ref={root}
        className="review-saved-document"
        dangerouslySetInnerHTML={{ __html: clean }}
      />
    </>
  );
}
